import GroupPermissionPresentation from 'components/organisms/presentations/GroupPermissionPresentation';

const GroupPermission = () => <GroupPermissionPresentation />;

export default GroupPermission;
